import { render, staticRenderFns } from "./commonMonthly.vue?vue&type=template&id=0a4d7f1a&scoped=true"
import script from "./commonMonthly.vue?vue&type=script&lang=js"
export * from "./commonMonthly.vue?vue&type=script&lang=js"
import style0 from "./commonMonthly.vue?vue&type=style&index=0&id=0a4d7f1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4d7f1a",
  null
  
)

export default component.exports